import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import '../../App.css';
import Logo from '../Admin/logo.webp';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import { BookModel } from '../../interfaces/book.interface';
import { PageDetailsModel } from '../../interfaces/common.interface';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import { fetchBookData } from './services/BookPageService';
import BookPageCard from './components/BookPageCard';
import BookBackCoverPage from './components/BookBackCover';
import BookCover from './components/BookCover';
import BookCopyright from './components/BookCopyright';

interface BookProps {
  bookIdAdmin?: string | null;
}

function BookPage({ bookIdAdmin = null }: BookProps) {
  const user = useSelector((state: RootState) => state.user.user);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [bookData, setBookData] = useState<BookModel | null>(null);
  const { bookId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedPageDetails, setSelectedPageDetails] = useState<PageDetailsModel | null>(null);
  const [storyText, setStoryText] = useState<string | null | undefined>(null);
  const [storyPhoto, setStoryPhoto] = useState<string | null | undefined>(null);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const fetchData = async () => {
    try {
      const { data, totalPages } = await fetchBookData(bookIdAdmin, bookId!);
      setBookData(data);
      setTotalPages(totalPages);
    } catch (error) {
    }
  };

  useEffect(() => {
    fetchData();
  }, [bookId, bookIdAdmin]);

  useEffect(() => {
    if (bookData?.pages) {
      const firstPageKey = `page1`;
      const firstPageDetails = bookData.pages[firstPageKey];
      if (firstPageDetails) {
        setStoryText(firstPageDetails?.text);
        setStoryPhoto(firstPageDetails?.imageURLwebp || firstPageDetails?.imageURL);
      }
    }
  }, [bookData]);
  if (!bookData) {
    return (
      <div>
        {!bookIdAdmin && <NavigationBar />}
        <LoadingSpinner size="w-16 h-16" />
      </div>
    );
  }

  const sortedPages = () => {
    if (!bookData?.pages) {
      return [];
    }

    return Object.entries(bookData.pages).sort(([pageKey1]: any, [pageKey2]: any) => {
      const pageNum1 = parseInt(pageKey1?.match(/\d+/)?.[0] ?? '0');
      const pageNum2 = parseInt(pageKey2?.match(/\d+/)?.[0] ?? '0');
      return pageNum1 - pageNum2;
    });
  };

  return (
    <div>
      {!bookIdAdmin && <NavigationBar />}
      <div className="bg-storytan p-4 mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-8">
          <BookCover storyPhoto={storyPhoto!} bookData={bookData} user={user} />
          <BookCopyright bookData={bookData} user={user} Logo={Logo} />
          {sortedPages().map(([pageKey, pageDetails], index) => (
            <BookPageCard
              key={index}
              pageDetails={pageDetails}
              index={index}
              totalPages={totalPages}
              bookData={bookData}
              isModalOpen={isModalOpen}
              handleCloseModal={handleCloseModal}
              selectedPageDetails={selectedPageDetails}
            />
          ))}
          {/* Back Cover last Blank Page */}
          <BookBackCoverPage bookData={bookData} />
        </div>
      </div>
    </div>
  );
}

export default BookPage;
